<template>
  <v-row align="start" justify="center">
    <v-col cols="3">
      <v-row align="center" justify="center">
        <SmallLogoEdit />
      </v-row>
    </v-col>
    <v-col cols="3">
      <v-row align="center" justify="center">
        <BigLogoEdit />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SmallLogoEdit from '@/components/manage/settings/SmallLogoEdit.vue';
import BigLogoEdit from '@/components/manage/settings/BigLogoEdit.vue';

export default {
  components: {
    SmallLogoEdit,
    BigLogoEdit
  }
};
</script>

<style lang="scss" scoped></style>
